<div class="loading-container">
  <i class="mdi mdi-loading text-primary position-fixed"></i>
</div>
<div *ngIf="msg" class="f-18 fw-500 text-secondary text-center pt-5 modal-text">
  {{msg}}
</div>
